__turbopack_context__.v({
  "Icon": "SocialLinks-module-sass-module__mzC9Aq__Icon",
  "SocialLinks": "SocialLinks-module-sass-module__mzC9Aq__SocialLinks",
});
